import {
  HOST,
  DEBUG_MODE,
  ARWEAVE_GATEWAY_MAIN,
  GLOBAL_RAW_ENTRIES_ARTISTS_AND_GENRECONTRACTS_FETCH_AND_RESPONSE_CACHE_REVALIDATE_MINUTES,
} from './config'
import { toTrimmedStringLowerCase } from './misc'

// #region Genre Images - PNG / JPG
const GENRE_IMAGE_AFRICA: string =
  ARWEAVE_GATEWAY_MAIN + 'vjKEXMsBCfizLYflKvGHmSO6enHV7muu6GZVMWyg3fQ'
const GENRE_IMAGE_POP: string =
  ARWEAVE_GATEWAY_MAIN + 'D5thlq7pJ3CrWw7b9Mww_EOZd4u_YPtjFomNKbdrZSc'
const GENRE_IMAGE_BLUES: string =
  ARWEAVE_GATEWAY_MAIN + 'SfMG64ulhkAckoqSLaY3Xp0W4UXa0nSyHKBtJ4MnAr0'
const GENRE_IMAGE_COMEDY: string =
  ARWEAVE_GATEWAY_MAIN + 'VST9KeoK631vFn7fcrMfaNd3xVZBMeqWBMuqmIg2AR4'
const GENRE_IMAGE_COUNTRY: string =
  ARWEAVE_GATEWAY_MAIN + 'xM6KsavzWcV_hFlCTwNOEcU0TNu5QsUFaVvMOKlh46w'
const GENRE_IMAGE_CLASSICAL: string =
  ARWEAVE_GATEWAY_MAIN + 'kns6FpRjkDNwBr-BWdvZ408lXWiTuhOby4RfFFPlpDM'
const GENRE_IMAGE_DANCE: string =
  ARWEAVE_GATEWAY_MAIN + 'yptPmzHCfiaMLxMPDh6UujKLEvJzvddv7xp8UV_0zHE'
const GENRE_IMAGE_ELECTRONIC: string =
  ARWEAVE_GATEWAY_MAIN + 'hfVbTyx2OS5bUa1_DCm-BhSx2Uyf6pY3EqrCvpIeK5g'
const GENRE_IMAGE_FOLK: string =
  ARWEAVE_GATEWAY_MAIN + 'fIsSyx80IBS4AO9Bc1XpdVJ3TH4qNRSzG8WYOToA8OE'
const GENRE_IMAGE_HIPHOP: string =
  ARWEAVE_GATEWAY_MAIN + 'ZAom9P7Qf7QCXtUZSwBid31fX4sLhMCEvr1T2xDfMkE'
const GENRE_IMAGE_JAZZ: string =
  ARWEAVE_GATEWAY_MAIN + 'ANFhHQlwh7kHztOSUbJv__gnunFfNPrcTpttDmgEkps'
const GENRE_IMAGE_KIDS: string =
  ARWEAVE_GATEWAY_MAIN + 'duIPSeGQ8Nl0nlrWoinVqEe6IfS3J8gtUAug58UGOsU'
const GENRE_IMAGE_LATIN: string =
  ARWEAVE_GATEWAY_MAIN + 'KUjHraf-la5wOgwJV-OmF-5W8Ns7PWVMkX6lEy0LFHo'
const GENRE_IMAGE_GLOBAL: string =
  ARWEAVE_GATEWAY_MAIN + 'uA4CQxn99YQbp07rO5JRzg8nXYWLOMULGJn-Rohklqo'
const GENRE_IMAGE_OLDIES_MOTOWN: string =
  ARWEAVE_GATEWAY_MAIN + 'uHKyUAPZ60-ZeF3FA6_rjv_228PupKzdtP99I_cexko'
const GENRE_IMAGE_METAL: string =
  ARWEAVE_GATEWAY_MAIN + 'O8QEe1Y0Ex9ZMJ4t3klS96EFZ0CSYFIMCVwXYghWoxs'
const GENRE_IMAGE_ROCK_INDIE: string =
  ARWEAVE_GATEWAY_MAIN + 'EzM67FDEE5g63pJNMO5wb2PK17IDSyz7Pq9zlhhUbTE'
const GENRE_IMAGE_R_AND_B_SOUL: string =
  ARWEAVE_GATEWAY_MAIN + 'MYLqBR7Gv5SPv6CNgcEDL8Fq60zu1m9QMxIB3n0dJJc'
const GENRE_IMAGE_INSTRUMENTALS: string =
  ARWEAVE_GATEWAY_MAIN + 'cPRL3rFRXMFZesxyCwf1X9TSNThWJUtcUiRto2NHCDU'
const GENRE_REGGAE_DANCEHALL: string =
  ARWEAVE_GATEWAY_MAIN + 'hyFagNNWdjiN_zgry_VDGT0apGRZPMnftvqLXI5RxeY'
// #endregion

// #region Genre Images - AVIF
const GENRE_IMAGE_AFRICA_AVIF: string =
  ARWEAVE_GATEWAY_MAIN + 'RiHYEbljoPiJAUVY5rRT2Aux4Iod6FnKM63vnf3Pf_Q'
const GENRE_IMAGE_POP_AVIF: string =
  ARWEAVE_GATEWAY_MAIN + 'XnDELaGRrNF9mklUSLLP91PVMaq4K1FvTiRBy2n07MM'
const GENRE_IMAGE_BLUES_AVIF: string =
  ARWEAVE_GATEWAY_MAIN + 'kh1hPlpPUmrdp9URq13xMrycsyW5XeYDU65fezPJrm8'
const GENRE_IMAGE_COMEDY_AVIF: string =
  ARWEAVE_GATEWAY_MAIN + '0rTzTSFqo_qrOIoYWia7ksf36S2_lM_acNY2omlFeK8'
const GENRE_IMAGE_COUNTRY_AVIF: string =
  ARWEAVE_GATEWAY_MAIN + 'PEOB6RdOFUQ6kE-aWFKJ9c6yk7Ub4U_iT54CU8RzWpo'
const GENRE_IMAGE_CLASSICAL_AVIF: string =
  ARWEAVE_GATEWAY_MAIN + 'dPcNLYW3EZEk08ylfuUxBiVRtMJp2XQjeC68dt4H8Vo'
const GENRE_IMAGE_DANCE_AVIF: string =
  ARWEAVE_GATEWAY_MAIN + 'V19fuKAISo_mlorIxpUhsWGkyCjjPXl4xPV_9QrU4HY'
const GENRE_IMAGE_ELECTRONIC_AVIF: string =
  ARWEAVE_GATEWAY_MAIN + 'tDDKiPQaYR6CxT0dwO9YAmnGj6GKDv3g17Y6Eg0Zwiw'
const GENRE_IMAGE_FOLK_AVIF: string =
  ARWEAVE_GATEWAY_MAIN + 'BCYyoZnyCjcrjck61uu6a2vTLLmYTPW7gXUvaVjD4zI'
const GENRE_IMAGE_HIPHOP_AVIF: string =
  ARWEAVE_GATEWAY_MAIN + '-Niy6LMJsiyyccsLavWwDuVyKJ3DaNE_0HUDJWtwLh0'
const GENRE_IMAGE_JAZZ_AVIF: string =
  ARWEAVE_GATEWAY_MAIN + 'm1NImW_A0UgQfA_V0b3BH6XxTnKBsn3L7oiXGzqfC1c'
const GENRE_IMAGE_KIDS_AVIF: string =
  ARWEAVE_GATEWAY_MAIN + 'fnKZTwPFRwwUCzumTmuyhjMLUBBEnghJT4M3I_CvgiI'
const GENRE_IMAGE_LATIN_AVIF: string =
  ARWEAVE_GATEWAY_MAIN + 'Rr9BPzE4wBbjfE0p5ioEZ5qCm3qPF_ukMUSeRxTg8t8'
const GENRE_IMAGE_GLOBAL_AVIF: string =
  ARWEAVE_GATEWAY_MAIN + 'Md6B_hFTxiB4aM6nrGX8vvsnFGgld6gdx5dsJ2DwtwI'
const GENRE_IMAGE_OLDIES_MOTOWN_AVIF: string =
  ARWEAVE_GATEWAY_MAIN + 'FsJ9sYFb4PIFE8f74_5BEs0u--Of5B7AZTSkyK__xRg'
const GENRE_IMAGE_METAL_AVIF: string =
  ARWEAVE_GATEWAY_MAIN + 'CJ0FyaCuCd0sk2tq2IAKMSrRBWaEtfWEUV8UK8r0M5o'
const GENRE_IMAGE_ROCK_INDIE_AVIF: string =
  ARWEAVE_GATEWAY_MAIN + 'DN23ccWTsaZmFG_md7fHXFn8CevnBIDR5hZSSYUxVTE'
const GENRE_IMAGE_R_AND_B_SOUL_AVIF: string =
  ARWEAVE_GATEWAY_MAIN + 'zdQzIuRasE4GEcN4iPDQc-xhXyRCPdl9TVdTjLxFX00'
const GENRE_IMAGE_INSTRUMENTALS_AVIF: string =
  ARWEAVE_GATEWAY_MAIN + '8YVf_JAaemZcL6y7cfkNOnTR_2duxjcIlPPoaTduUsI'
const GENRE_REGGAE_DANCEHALL_AVIF: string =
  ARWEAVE_GATEWAY_MAIN + 'er_J-AZz8hR_-6VQeRAe7NuqnONNxcy5pv1tWoP-DlA'
// #endregion

// #region Genre Thumbs - PNG / JPG
const GENRE_IMAGE_AFRICA_THUMB: string =
  ARWEAVE_GATEWAY_MAIN + 'jIuhhJsDScL-PiiHDqRFKqHatN0-aL2kX6rr097E83s'
const GENRE_IMAGE_POP_THUMB: string =
  ARWEAVE_GATEWAY_MAIN + '-UmxuU0BLoTCRESYW9RAvZL5D95KYOPTdt_V_Zv8NLs'
const GENRE_IMAGE_BLUES_THUMB: string =
  ARWEAVE_GATEWAY_MAIN + 'JkEzh6lyuXFHaIrb8OUaqUazmYC2QWT-jXYsOuQWRTw'
const GENRE_IMAGE_COMEDY_THUMB: string =
  ARWEAVE_GATEWAY_MAIN + '0FPnXosMmGuuXe17YzBBGzorJ3tiftl69h3smfTpMYA'
const GENRE_IMAGE_COUNTRY_THUMB: string =
  ARWEAVE_GATEWAY_MAIN + 'Z9uimOyznGAYvgzmypPXSGqOH1a4SijuM1fmPKgrUuk'
const GENRE_IMAGE_CLASSICAL_THUMB: string =
  ARWEAVE_GATEWAY_MAIN + 'Dz1s6UXrYB0xqQG1ntyf13x8qqtT6hFhmjFlX05y4m8'
const GENRE_IMAGE_DANCE_THUMB: string =
  ARWEAVE_GATEWAY_MAIN + 'iCqYr1S-WzE2g1GFHz6ohULO4-txHYati_BRF6cdGps'
const GENRE_IMAGE_ELECTRONIC_THUMB: string =
  ARWEAVE_GATEWAY_MAIN + 'hOFDkmTuhV9O5PoRQJK7lwXqvcu_d8rslfkPbHunJmc'
const GENRE_IMAGE_FOLK_THUMB: string =
  ARWEAVE_GATEWAY_MAIN + 'upzPMb9PbYC0FdZ0qd-OWLPX8VHMq3QaRy1-B21teaA'
const GENRE_IMAGE_HIPHOP_THUMB: string =
  ARWEAVE_GATEWAY_MAIN + 'uv2tpKtOu6nWbcQXP_lEoIZEXqRo6QfFByuJDkEUZxs'
const GENRE_IMAGE_JAZZ_THUMB: string =
  ARWEAVE_GATEWAY_MAIN + 'arNK8rWGXU8w-aHptMzNpP29Ul2WAvTXxjkKUhIgVTY'
const GENRE_IMAGE_KIDS_THUMB: string =
  ARWEAVE_GATEWAY_MAIN + 'PwHg7qPT4yefdXw48PCJCkInKPyQlaRXKQXYK_Qhrks'
const GENRE_IMAGE_LATIN_THUMB: string =
  ARWEAVE_GATEWAY_MAIN + 'WF4TKc-smWa3ARhRVUi8IPE2ixEfqKApPBchJn1zIuE'
const GENRE_IMAGE_GLOBAL_THUMB: string =
  ARWEAVE_GATEWAY_MAIN + 'flNNZXVcy-2HV0NJJ0Wofs3tF9Ij3ohubkHbyXSl0w0'
const GENRE_IMAGE_OLDIES_MOTOWN_THUMB: string =
  ARWEAVE_GATEWAY_MAIN + '-sEm6vSIiaxo38BhMQyOIwlR1_6oxv5eYr6lRfkE6BM'
const GENRE_IMAGE_METAL_THUMB: string =
  ARWEAVE_GATEWAY_MAIN + 'HGk24gNzeW7xBIXf2TSRqqqew3iKfgfKc18tWs2MSO4'
const GENRE_IMAGE_ROCK_INDIE_THUMB: string =
  ARWEAVE_GATEWAY_MAIN + 'cudw8xdOh9HESCQMiNKRX-zubTs-wzXNYF_mxGuUU2A'
const GENRE_IMAGE_R_AND_B_SOUL_THUMB: string =
  ARWEAVE_GATEWAY_MAIN + 'n4DXH40jVEwLfKpY-c0RZMHzy42JAj9nYcglDJUR5PE'
const GENRE_IMAGE_INSTRUMENTALS_THUMB: string =
  ARWEAVE_GATEWAY_MAIN + '4BCiJeezQq0p9Hm6GEaLMuWy9fQRB-DV4ZhR_8vnx-A'
const GENRE_REGGAE_DANCEHALL_THUMB: string =
  ARWEAVE_GATEWAY_MAIN + 'wTXrhyVLoc72lmORDQ09uGiY_55MwgaOPdM8nyps_hM'
//#endregion

export function getThumbForGenre(genre: any) {
  let ret: string = ''
  let frmGenre: string = toTrimmedStringLowerCase(genre)
  try {
    if (frmGenre == 'pop') ret = GENRE_IMAGE_POP_THUMB
    else if (frmGenre == 'blues') ret = GENRE_IMAGE_BLUES_THUMB
    else if (frmGenre == 'africa') ret = GENRE_IMAGE_AFRICA_THUMB
    else if (frmGenre == 'comedy') ret = GENRE_IMAGE_COMEDY_THUMB
    else if (frmGenre == 'classical') ret = GENRE_IMAGE_CLASSICAL_THUMB
    else if (frmGenre == 'country') ret = GENRE_IMAGE_COUNTRY_THUMB
    else if (frmGenre == 'dance') ret = GENRE_IMAGE_DANCE_THUMB
    else if (frmGenre == 'electronic') ret = GENRE_IMAGE_ELECTRONIC_THUMB
    else if (frmGenre == 'folk / american') ret = GENRE_IMAGE_FOLK_THUMB
    else if (frmGenre == 'rap / hip-hop') ret = GENRE_IMAGE_HIPHOP_THUMB
    else if (frmGenre == 'jazz') ret = GENRE_IMAGE_JAZZ_THUMB
    else if (frmGenre == 'kids') ret = GENRE_IMAGE_KIDS_THUMB
    else if (frmGenre == 'latin') ret = GENRE_IMAGE_LATIN_THUMB
    else if (frmGenre == 'global') ret = GENRE_IMAGE_GLOBAL_THUMB
    else if (frmGenre == 'oldies / motown')
      ret = GENRE_IMAGE_OLDIES_MOTOWN_THUMB
    else if (frmGenre == 'metal') ret = GENRE_IMAGE_METAL_THUMB
    else if (frmGenre == 'rock / indie') ret = GENRE_IMAGE_ROCK_INDIE_THUMB
    else if (frmGenre == 'r&b / soul') ret = GENRE_IMAGE_R_AND_B_SOUL_THUMB
    else if (frmGenre == 'instrumentals') ret = GENRE_IMAGE_INSTRUMENTALS_THUMB
    else if (frmGenre == 'reggae / dancehall')
      ret = GENRE_REGGAE_DANCEHALL_THUMB
    else ret = ''
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

export function getImageForGenre(genre: any, avifCompatible: boolean | null) {
  let ret: string = ''
  let frmGenre: string = toTrimmedStringLowerCase(genre)
  try {
    if (frmGenre == 'pop')
      ret = avifCompatible ? GENRE_IMAGE_POP_AVIF : GENRE_IMAGE_POP
    else if (frmGenre == 'blues')
      ret = avifCompatible ? GENRE_IMAGE_BLUES_AVIF : GENRE_IMAGE_BLUES
    else if (frmGenre == 'africa')
      ret = avifCompatible ? GENRE_IMAGE_AFRICA_AVIF : GENRE_IMAGE_AFRICA
    else if (frmGenre == 'comedy')
      ret = avifCompatible ? GENRE_IMAGE_COMEDY_AVIF : GENRE_IMAGE_COMEDY
    else if (frmGenre == 'classical')
      ret = avifCompatible ? GENRE_IMAGE_CLASSICAL_AVIF : GENRE_IMAGE_CLASSICAL
    else if (frmGenre == 'country')
      ret = avifCompatible ? GENRE_IMAGE_COUNTRY_AVIF : GENRE_IMAGE_COUNTRY
    else if (frmGenre == 'dance')
      ret = avifCompatible ? GENRE_IMAGE_DANCE_AVIF : GENRE_IMAGE_DANCE
    else if (frmGenre == 'electronic')
      ret = avifCompatible
        ? GENRE_IMAGE_ELECTRONIC_AVIF
        : GENRE_IMAGE_ELECTRONIC
    else if (frmGenre == 'folk / american')
      ret = avifCompatible ? GENRE_IMAGE_FOLK_AVIF : GENRE_IMAGE_FOLK
    else if (frmGenre == 'rap / hip-hop')
      ret = avifCompatible ? GENRE_IMAGE_HIPHOP_AVIF : GENRE_IMAGE_HIPHOP
    else if (frmGenre == 'jazz')
      ret = avifCompatible ? GENRE_IMAGE_JAZZ_AVIF : GENRE_IMAGE_JAZZ
    else if (frmGenre == 'kids')
      ret = avifCompatible ? GENRE_IMAGE_KIDS_AVIF : GENRE_IMAGE_KIDS
    else if (frmGenre == 'latin')
      ret = avifCompatible ? GENRE_IMAGE_LATIN_AVIF : GENRE_IMAGE_LATIN
    else if (frmGenre == 'global')
      ret = avifCompatible ? GENRE_IMAGE_GLOBAL_AVIF : GENRE_IMAGE_GLOBAL
    else if (frmGenre == 'oldies / motown')
      ret = avifCompatible
        ? GENRE_IMAGE_OLDIES_MOTOWN_AVIF
        : GENRE_IMAGE_OLDIES_MOTOWN
    else if (frmGenre == 'metal')
      ret = avifCompatible ? GENRE_IMAGE_METAL_AVIF : GENRE_IMAGE_METAL
    else if (frmGenre == 'rock / indie')
      ret = avifCompatible
        ? GENRE_IMAGE_ROCK_INDIE_AVIF
        : GENRE_IMAGE_ROCK_INDIE
    else if (frmGenre == 'r&b / soul')
      ret = avifCompatible
        ? GENRE_IMAGE_R_AND_B_SOUL_AVIF
        : GENRE_IMAGE_R_AND_B_SOUL
    else if (frmGenre == 'instrumentals')
      ret = avifCompatible
        ? GENRE_IMAGE_INSTRUMENTALS_AVIF
        : GENRE_IMAGE_INSTRUMENTALS
    else if (frmGenre == 'reggae / dancehall')
      ret = avifCompatible
        ? GENRE_REGGAE_DANCEHALL_AVIF
        : GENRE_REGGAE_DANCEHALL
    else ret = ''
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

export const GET_CONTRACTS_FOR_GENRES_CALLSTRING: string[] = [
  `self.addEventListener('message', async (event) => {
      if (event.data != undefined && event.data != null && event.data.toString().trim() != '') {
        try {
          if (event?.data?.genreId != null && event?.data?.genreId?.toString().trim() != '') {
            const opts = {
              method: 'GET',
              headers: {
                'genreId': event?.data?.genreId,
              },
              next: { revalidate: ${(
                GLOBAL_RAW_ENTRIES_ARTISTS_AND_GENRECONTRACTS_FETCH_AND_RESPONSE_CACHE_REVALIDATE_MINUTES *
                60
              ).toString()} }, 
            }
            await fetch('${HOST}' + '/api/p.stream-sv/g/ggc', opts)
              .then(async (x) => {
                const ret = await x.json()
                self.postMessage(ret?.genreContracts?.length > 0 ? ret?.genreContracts : [])
              })
              .catch((e) => {
                if (${DEBUG_MODE}) console.log(e)
                self.postMessage([])
              })
          } else self.postMessage([])
        } catch (e) {
          if (${DEBUG_MODE}) console.log(e)
          self.postMessage([])
        }
      } else self.postMessage([])
    })`,
]

export const STATIC_GENRES = [
  {
    value: 1,
    label: 'Africa',
    labelSpanish: 'África',
    labelFrench: 'Afrique',
    labelKorean: '아프리카',
  },
  {
    value: 2,
    label: 'Blues',
    labelSpanish: 'Blues',
    labelFrench: 'Blues',
    labelKorean: '블루스',
  },
  {
    value: 3,
    label: 'Classical',
    labelSpanish: 'Clásico',
    labelFrench: 'Classique',
    labelKorean: '고전',
  },
  {
    value: 4,
    label: 'Comedy',
    labelSpanish: 'Comedia',
    labelFrench: 'Comédie',
    labelKorean: '코메디',
  },
  {
    value: 5,
    label: 'Country',
    labelSpanish: 'Country',
    labelFrench: 'Country',
    labelKorean: '컨트리',
  },
  {
    value: 6,
    label: 'Dance',
    labelSpanish: 'Baile',
    labelFrench: 'Danse',
    labelKorean: '댄스',
  },
  {
    value: 7,
    label: 'Electronic',
    labelSpanish: 'Electrónica',
    labelFrench: 'Électronique',
    labelKorean: '일렉트로닉',
  },
  {
    value: 20,
    label: 'Instrumentals',
    labelSpanish: 'Instrumentales',
    labelFrench: 'Instrumentales',
    labelKorean: '악기',
  },
  {
    value: 11,
    label: 'Jazz',
    labelSpanish: 'Jazz',
    labelFrench: 'Jazz',
    labelKorean: '재즈',
  },
  {
    value: 12,
    label: 'Kids',
    labelSpanish: 'Churumbeles',
    labelFrench: 'Enfants',
    labelKorean: '어린이들',
  },
  {
    value: 13,
    label: 'Latin',
    labelSpanish: 'Latina',
    labelFrench: 'Latin',
    labelKorean: '라틴 음악',
  },
  {
    value: 15,
    label: 'Metal',
    labelSpanish: 'Metal',
    labelFrench: 'Métal',
    labelKorean: '메탈 음악',
  },
  {
    value: 14,
    label: 'Oldies / Motown',
    labelSpanish: 'Oldies / Motown',
    labelFrench: 'Oldies / Motown',
    labelKorean: '옛날 / 모타운',
  },
  {
    value: 16,
    label: 'Pop',
    labelSpanish: 'Popular',
    labelFrench: 'Populaire',
    labelKorean: '대중 음악',
  },
  {
    value: 18,
    label: 'R&B / Soul',
    labelSpanish: 'R&B / Alma',
    labelFrench: 'R&B / Áme',
    labelKorean: '알앤비 / 소울',
  },
  {
    value: 10,
    label: 'Rap / Hip-Hop',
    labelSpanish: 'Rap / Hip-Hop',
    labelFrench: 'Rap / Hip-Hop',
    labelKorean: '랩 / 힙합',
  },
  {
    value: 21,
    label: 'Reggae / Dancehall',
    labelSpanish: 'Reggae',
    labelFrench: 'Reggae',
    labelKorean: '레게',
  },
  {
    value: 17,
    label: 'Rock / Indie',
    labelSpanish: 'Roca',
    labelFrench: 'Rocher / Indie',
    labelKorean: '대중음악',
  },
]
